/** @jsxImportSource @emotion/react */
import {
  FeedCard,
  Column,
  Text,
  TEXT_VARIANTS,
  Tagline,
  ExternalLink,
} from "../..";

export const AudioCard: React.FC = () => (
  <FeedCard path="/audio/id">
    <Column gap={10}>
      <iframe
        title="Apple podcast player"
        allow="autoplay *; encrypted-media *; fullscreen *; clipboard-write"
        frameBorder="0"
        height="175"
        sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-storage-access-by-user-activation allow-top-navigation-by-user-activation"
        src="https://embed.podcasts.apple.com/us/podcast/why-you-should-seek-power-not-happiness-nietzsches/id1364706343?i=1000589705728"
      ></iframe>
      <Column crossAxisAlignment="start" gap={5}>
        <Text as="h3" variant={TEXT_VARIANTS.T30}>
          {
            "Why You Should Seek Power, Not Happiness - Nietzsche's Guide to Greatness"
          }
        </Text>
        <Text as="p" variant={TEXT_VARIANTS.T20}>
          {"Hiking Treks"}
        </Text>
        <Tagline
          text="audio · by $0"
          entities={[{ type: "person", name: "Academy of Ideas" }]}
        />
        <ExternalLink>{"podcasts.apple.com"}</ExternalLink>
      </Column>
    </Column>
  </FeedCard>
);
